import {
  InteractiveContentWrapper,
  ModalOverlay,
  OverlayActionContainer,
  PositionRelativeContainer,
} from "../styles/StyledComponents";

// Define the Props type
interface InteractiveOverlayProps {
  isAllowed: boolean;
  children: React.ReactNode; // Content to be rendered inside the wrapper
  actionComponent?: React.ReactNode; // Optional action component (e.g., a button)
}

// Create the common component
const InteractiveOverlay: React.FC<InteractiveOverlayProps> = ({
  isAllowed,
  children,
  actionComponent,
}) => {
  return (
    <PositionRelativeContainer>
      <InteractiveContentWrapper isInteractive={isAllowed}>
        {children} {/* Render the children passed to the component */}
      </InteractiveContentWrapper>
      {/* ModalOverlay with button, visibility and interactivity depend on permission */}
      <ModalOverlay isVisible={!isAllowed}>
        <OverlayActionContainer>
          {actionComponent || (
            <></> // Fallback if no action component is provided
          )}
        </OverlayActionContainer>
      </ModalOverlay>
    </PositionRelativeContainer>
  );
};

export default InteractiveOverlay;
